import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-playgrounds',
  templateUrl: './playgrounds.component.html',
  styleUrls: ['./playgrounds.component.scss']
})
export class PlaygroundsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
